<template>
  <li v-if="isAllowed">
    <router-link :to="link" v-if="isAllowed && useRouterLink">
      <div class="menu-icon bg-secondary" v-b-tooltip.hover :title="title">
        <feather-icon v-if="useFeatherIcon" :icon="icon" svgClasses="text-white stroke-current w-5 h-5" />
        <span v-if="useFontAwesomeIcon" style="color: white;">
          <font-awesome-icon :icon="fontAwesomeIcon" />
        </span>
      </div>
      <div class="menu-text">
        <a v-b-tooltip.hover :title="title">{{ title }}</a>
      </div>
    </router-link>
    <div v-if="isAllowed && !useRouterLink">
      <div class="menu-icon bg-secondary" v-b-tooltip.hover :title="title">
        <feather-icon v-if="useFeatherIcon" :icon="icon" svgClasses="text-white stroke-current w-5 h-5" />
        <span v-if="useFontAwesomeIcon" style="color: white;">
          <font-awesome-icon :icon="fontAwesomeIcon" />
        </span>
      </div>
      <div class="menu-text">
        <a :href="link" target="_blank" v-b-tooltip.hover :title="title">{{ title }}</a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    fontAwesomeIcon: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: String,
      required: true
    },
    roles: {
      type: Array,
      required: true
    }    
  },
  computed: {
    isAllowed () {
      return this.$auth.checkRoles(this.$props.roles);
    },
    useFeatherIcon () {
      return this.$props.icon !== null;
    },
    useFontAwesomeIcon () {
      return this.$props.fontAwesomeIcon !== null;
    },
    useRouterLink () {
      return this.$props.link.startsWith("/");
    }
  }
}
</script>
<style lang="scss">
.menu_line {
  li {
    position: relative;
    margin-bottom: 40px;

    .menu-icon {
      position: absolute;
      top: 0;
      left: -4.3rem;
      border-radius: 50%;
      padding: .75rem;
      padding-bottom: 0.4rem;
    }

    .menu-text {
      text-align: left;
      padding-top:0.4rem;
    }
  }
}
</style>